import React from 'react'

// components
import ErrorContents from './ErrorContents'
import { Button, Panel, If } from 'src/Components'

// providers
import { useSignUpProvider } from '../SignUpContext'

// assets
import { IconTimes } from 'src/Components/shared/Icon'

// styles
import styles from './SignUpError.module.scss'

const SignUpError = () => {
  const { submitError, setSubmitError } = useSignUpProvider()

  return (
    <If condition={submitError}>
      <div className={styles.modal}>
        <div className={styles.container}>
          <Button
            className={styles.close}
            iconStart={IconTimes}
            onClick={() => setSubmitError(false)}
          />
          <Panel>
            <ErrorContents />
          </Panel>
        </div>
      </div>
    </If>
  )
}

export default SignUpError
